<template>
  <div class="app-news">
    <div class="news-title">
      <h2>{{ newsForm.newsTitle }}</h2>
    </div>
    <div class="news-infos" v-html="newsForm.newsDesc">
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newsForm: {
        newsId:'',
        newsTitle: '',
        newsDesc: '',
        newsType: '',
        createdTime: ''
      }
    }
  },
  created() {
    debugger
    this.newsForm.newsId = this.$route.params.id
    this.handleSearch()
  },
  methods: {
    handleSearch() {
      this.$axios.get('/api/news/findDetail/'+this.newsForm.newsId).then(res => {
        if (res.data.code = 200) {
          debugger
          this.newsForm = res.data.result || {}
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
.app-news {
  padding: 70px 130px;
  min-height: 600px;
  background-color: #fff;
}
.app-news .news-title {
  text-align: center;
  color: dodgerblue;
}
.app-news .news-desc {
  text-align: center;
  color: dodgerblue;
}
.app-news .news-infos {
    flex: 1;
    height: 100%;
    margin-top: 2.5rem;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    display: flex;
    flex-direction: column;
    // justify-content: center;
    // align-items: center;
    .lang{
      font-size: 0.191rem;
      line-height: 18px;
      color: #000;

    }
    .author{

      padding-top:6px;
      font-size: 0.191rem;
      color: #000;
      width: 100%;
      text-align: right;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/NewsDetail.vue